import classname from './classname';
import * as clone from './clone';
import * as color from './color';
import * as flat from './flat';
import * as func from './func';
import hash from './hash';
import * as is from './is';
import * as number from './numbers';
import * as objects from './objects';
import shallowEqual from './shallowEqual';
import * as string from './strings';
import * as tree from './tree';
import * as detect from './dom/detect';
import * as doc from './dom/document';
import * as element from './dom/element';
import normalizeWheel from './dom/normalizeWheel';
import * as position from './dom/popover';
import ready from './dom/ready';
import isJson from './validate/isJson';
import * as type from './type';
import { util } from '@sheinx/hooks';

import accept from './accept';

const validate = util.validate;
const cssAccessors = {};
const cssInject = {};

export {
  classname,
  clone,
  color,
  flat,
  func,
  hash,
  is,
  number,
  objects,
  shallowEqual,
  string,
  tree,
  detect,
  doc,
  element,
  normalizeWheel,
  position,
  ready,
  isJson,
  validate,
  cssAccessors,
  cssInject,
  type,
  accept,
};
